import { useEffect, useState } from "react";
import { getOneProduct } from "../../api-route/product";
import { useLocation, useParams } from "react-router-dom";
import { BreadcrumbItem, Breadcrumbs } from "@nextui-org/react";
import Article from "../../Components/DetailPaint/article";
import { Helmet } from "react-helmet";

export default function Page() {
    const { slug } = useParams()
    const location = useLocation();
    const canonicalUrl = `${window.location.origin}${location.pathname}`;
    const [product, setProduct] = useState()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const get = async () => {
            if (!slug) return; // Ensure `slug` is defined
            try {
                const data = await getOneProduct(slug);
                if (data) {
                    setProduct(data)
                } else {
                    setError("تابلو پیدا نشد");
                }
            } catch (err) {
                setError("مشکل در بارگزاری اطلاعات");
            } finally {
                setLoading(false);
            }
        }
        get()
    }, [slug])

    if (loading)
        return <div className="centerOfParent h-screen w-full">درحال‌بارگذاری</div>;


    if (error)
        return <div className="centerOfParent h-screen w-full">{error}</div>;


    if (!product)
        return <div className="centerOfParent h-screen w-full">اطلاعاتی از این محصول در دسترس نیست</div>;


    return (
        <>
            <Helmet>
                <title>{product?.seo_title || product?.title}</title>
                <meta name="description" content={product?.meta_description || product?.body?.replace(/<\/?[^>]+(>|$)/g, "").slice(0, 600)} />
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>
            <div className="container">
                <Breadcrumbs separator='/' className="py-6" itemClasses={{ separator: "px-2" }} dir="rtl">
                    <BreadcrumbItem href="/">صفحه اصلی</BreadcrumbItem>
                    <BreadcrumbItem href='/ready-product'>تابلوهای آماده</BreadcrumbItem>
                    <BreadcrumbItem>{product.title_persian || product.title}</BreadcrumbItem>
                </Breadcrumbs>
                <Article {...{ Painting: product, width: product.width_pixel, height: product.height_pixel, withFrame: true }} />
            </div>
        </>
    );
}